export default "__VITE_ASSET__a5m5Jmzw__"